var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "15px",
    viewBox: "0 0 12 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Functional/Light/Image") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WISYWIG",
    transform: "translate(-626.000000, -472.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(420.000000, 462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Functional/Light/Bold-Text",
    transform: "translate(201.355932, 7.118644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.96475,17.5 L5.16775,3.15 L11.424,3.15 C12.964,3.15 14.17675,3.5735 14.94675,4.3435 C15.56275,4.9595 15.87075,5.71025 15.87075,6.63425 C15.87075,8.1935 15.06225,9.0405 14.09975,9.5795 C15.659,10.17625 16.6215,11.081 16.6215,12.8905 L16.6215,13.125 C16.6215,15.589 14.4165,17.5 11.375,17.5 L4.96475,17.5 Z M7.875,8.75 L10.9375,8.75 C12.2465,8.75 12.9255,8.3125 12.9255,7.249375 C12.9255,6.125 12.18875,5.74875 10.9375,5.74875 L7.875,5.74875 L7.875,8.75 Z M7.85225,14.4375 L11.375,14.4375 C12.684,14.4375 13.67625,13.937875 13.67625,12.6875 C13.67625,11.8125 12.89575,11.06175 11.375,11.06175 L7.875,11.06175 L7.85225,14.4375 Z",
    id: "Path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB);
export default __webpack_public_path__ + "static/media/b.a9b115a5651a2bc5a57ae90d86f82ff5.svg";
export { ForwardRef as ReactComponent };